import { authHeader, responseHandler, AP_PINMED_URL } from "@/helpers"
import { fetch } from "@/helpers/atlasFetch"

const fetchByToken = () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  }

  return fetch(`${AP_PINMED_URL}/me`, requestOptions).then(responseHandler)
}

export const resendConfirmationEmail = () => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  }

  return fetch(`${AP_PINMED_URL}/users/resend_confirmation_email`, requestOptions).then(
    responseHandler
  )
}

export const verifyEmail = token => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }

  return fetch(`${AP_PINMED_URL}/users/verify?token=${token}`, requestOptions).then(responseHandler)
}

export const sendResetPasswordEmail = email => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
    }),
  }

  return fetch(`${AP_PINMED_URL}/users/send_reset_password_email`, requestOptions).then(
    responseHandler
  )
}

export const resetPassword = data => {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }

  return fetch(`${AP_PINMED_URL}/users/reset_password`, requestOptions).then(responseHandler)
}

// const resendConfirmationEmail = async () =>
//   fetch(`${AP_PINMED_URL}/users/resend_confirmation_email`, requestOptions)
//     .then(responseHandler)

const userService = {
  fetchByToken,
  verifyEmail,
}

export default userService
